var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoCetim(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 692.58 110.14",
    style: {
      enableBackground: "new 0 0 692.58 110.14"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#001E50;}\n\t.st1{fill:#EF3346;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.43,108.52c-10.04,0-19.05-2.4-27.01-7.19c-7.97-4.79-14.2-11.27-18.71-19.44 c-4.5-8.16-6.75-17.1-6.75-26.82c0-9.65,2.25-18.56,6.75-26.72c4.5-8.16,10.74-14.66,18.71-19.48c7.97-4.83,16.97-7.24,27.01-7.24 c8.81,0,16.76,1.75,23.86,5.25c7.09,3.5,12.99,8.31,17.69,14.43c4.7,6.12,7.92,13.07,9.67,20.84h-28.76 c-1.88-4.79-4.78-8.37-8.7-10.74c-3.92-2.36-8.47-3.55-13.65-3.55c-4.28,0-8.29,1.09-12.05,3.26c-3.76,2.17-6.77,5.3-9.04,9.38 c-2.27,4.08-3.4,8.94-3.4,14.58c0,5.64,1.15,10.51,3.45,14.62c2.3,4.11,5.31,7.26,9.04,9.43c3.72,2.17,7.73,3.26,12,3.26 c3.43,0,6.61-0.53,9.52-1.6c2.92-1.07,5.47-2.8,7.68-5.2c2.2-2.4,3.92-5.44,5.15-9.13h28.67c-1.62,8.16-4.76,15.42-9.43,21.77 c-4.66,6.35-10.58,11.32-17.73,14.92C284.23,106.72,276.24,108.52,267.43,108.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M337.25,4.83h72.2V26.5h-44.21v18.85h37.41v18.37h-37.41v19.92h44.89v21.67h-72.88V4.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M452.57,28.93h-26.43V4.83h80.85v24.1h-26.43v76.38h-27.99V28.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M523.75,4.83h27.99v100.48h-27.99V4.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M578.02,4.83h25.07l30.61,46.64l0.19-0.1L664.6,4.83h24.97v100.48h-26.14V44.48h-0.1l-25.07,38.87h-9.13 l-24.78-38.97h-0.1v60.93h-26.24V4.83z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 86.73,
    y: 71.8,
    className: "st1",
    width: 33.49,
    height: 33.49
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "3,38.31 3,105.29 36.49,105.29 36.49,71.8 86.73,71.8 86.73,38.31  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165.74,4.82h-12.03h-33.49H86.73v33.49h33.49h33.49V71.8v33.49h33.49V71.8V38.31V26.27 C187.2,14.42,177.59,4.82,165.74,4.82z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCetim);
export default __webpack_public_path__ + "static/media/logo_cetim.00c600071eda000e56979e9531665026.svg";
export { ForwardRef as ReactComponent };